import React from 'react';

import { Badge } from '@change/ds-core-ui/Badge';
import { Text } from '@change/ds-core-ui/Text';
import { cn } from '@change/ds-utils';

export type InfoSectionConnector = 'responsive' | 'tall';

export const InfoSection: React.FC<Props> = ({
	className,
	icon,
	title,
	subtitle,
	titleSize = 'small',
	badge,
	children,
	connector = 'responsive',
}) => {
	return (
		<div className={cn('mx-auto flex max-w-87.5 flex-col items-center gap-11', className)}>
			<div className="flex flex-col items-center gap-6 px-4 text-center md:px-0">
				<div className="flex flex-col items-center">
					<div
						className={cn(
							'via-stroke-weaker to-stroke-weaker w-0.5 bg-linear-to-b from-transparent',
							connector === 'tall' ? 'h-20' : 'h-10 md:h-20',
						)}
					/>
					<div className="text-icon-information bg-fill-inverse-strong border-stroke-weaker flex h-12 w-12 items-center justify-center rounded-full border-2">
						{icon}
					</div>
				</div>

				<div className="flex flex-col items-center gap-2">
					<Text as="h2" variant="heading" size={titleSize}>
						{title}
					</Text>
					{typeof subtitle === 'string' ? <Text as="p">{subtitle}</Text> : subtitle}
				</div>

				{badge && <Badge emphasis="strong" label={badge} size="small" />}
			</div>

			{children ?? null}
		</div>
	);
};

type Props = Readonly<{
	icon: React.ReactNode;
	title: string;
	subtitle: React.ReactNode;
	titleSize?: 'small' | 'medium';
	badge?: React.ReactNode;
	children?: React.ReactNode;
	className?: string;
	connector?: InfoSectionConnector;
}>;
